export default {
  resetUser (state) {
    state.user = null
  },
  insertUser (state, newvalue) {
    state.user = newvalue
  },
  updateUser (state, newvalue) {
    state.user = { ...state.user, ...newvalue }
  },
  setTokenWithoutBearer (state, newvalue) {
    state.tokenWithoutBearer = newvalue
  },
  deleteDocument (state, udid) {
    state.user.uploads = state.user.documents.filter(doc => doc.udid !== udid)
  },
  deleteUpload (state, udid) {
    state.user.uploads = state.user.uploads.filter(doc => doc.udid !== udid)
  },
  updateIban (state, newvalue) {
    state.user.customer.money.iban = newvalue
  },
  setDocuments (state, newvalue) {
    state.user.documents = newvalue
  },
  updateAllowWebid (state, newvalue) {
    state.user.customer.allow_web_id = newvalue
  },
  changeTopInsurance (state, newvalue) {
    state.topInsurance = newvalue
  },
  changeDirectInsurance (state, newvalue) {
    state.directInsurance = newvalue
  },
  changePath (state, newvalue) {
    state.path = newvalue
  },
  changeSanierungsStatus (state, newvalue) {
    state.sanierungsStatus = newvalue
  },
  setDocumentStatus (state, payload) {
    state.documentStatus = {
      resolved: true,
      sigma: {
        has_signed_contract: payload?.sigma?.has_signed_contract === true,
        has_existenzschutz: payload?.sigma?.has_existenzschutz === true
      },
      starpool_signed: payload?.starpool_signed === true,
      starpool_wuerzburger_signed: payload?.starpool_wuerzburger_signed === true,
      gbv: {
        has_signature: payload?.gbv?.has_signature === true
      }
    }
  },
  setKrankenkasse (state, payload) {
    state.krankenkasse = { ...state.krankenkasse, ...payload }
  },
  setKrankenkasseSubscribed (state, newvalue) {
    state.krankenkasse = { ...state.krankenkasse, subscribed: newvalue }
  }
}
